import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@omni/components/components/Wishlist/WishlistHeaderButton/wishlistHeaderButton.container"
    ).then((module) => ({
        default: module.WishlistHeaderButtonContainer
    }))
);
